import React, { useCallback } from 'react'
import { TAG_BLOC_HOTEL } from '../analytics/analytics.tagids.constants'
import { navigateToSearchBySubcategory } from '../../store/history/history.actions'
import TagActionButton from '../genericComponents/TagActionButton'
import calendar from '../genericComponents/assets/calendar.svg'
import RectangleActionButton, { COLOR_DARKBLUE, SIZE_MEDIUM } from '../genericComponents/buttons/RectangleActionButton'
import HotelDateInput from '../geoentity/HotelDateInput'
import { withFrenchSite } from '../i18n/i18nSite'
import SVGIcon from '../svg/SVGIcon'
import { formatDate, getFutureDate } from '../utils/date'
import { useAction } from '../utils/react-redux'
import s from './FakeHotelCalendar.less'

const FakeHotelCalendar = () => {
  const execNavigateToSearchBySubcategory = useAction(navigateToSearchBySubcategory)
  const onClick = useCallback(() => execNavigateToSearchBySubcategory('hotel'), [execNavigateToSearchBySubcategory])

  return (
    <div className={s.FakeHotelCalendarContainer}>
      <TagActionButton type={TAG_BLOC_HOTEL} className={s.FakeHotelCalendar} onClick={onClick} deferClick>
        <div className={s.titleContainer}>
          <span className={s.title}>{"Tous les hôtels près d'ici"}</span>
        </div>
        <div className={s.datePickersContainer}>
          <HotelDateInput label="Arrivée" date={formatDate(getFutureDate({ days: 30 }))} />
          <div className={s.toDate}>
            <HotelDateInput label="Départ" date={formatDate(getFutureDate({ days: 31 }))} />
          </div>
          <SVGIcon url={calendar} className={s.calendarIcon} />
        </div>
        <div className={s.buttonContainer}>
          <RectangleActionButton color={COLOR_DARKBLUE} label="Voir les hôtels" icon="hotel-hebergement" size={SIZE_MEDIUM} />
        </div>
      </TagActionButton>
    </div>
  )
}

export default withFrenchSite(FakeHotelCalendar)
